import axios from "axios";

const homeStore = {
  namespaced: true,
  state: {
    dialogCredRecebidos: false,
    dialogGastosCliente: false,
    dialogGastosConsumo: false,
    termosPendentes: [],
  },
  mutations: {
    setDialogCredRecebidos(state, dialog) {
      state.dialogCredRecebidos = dialog;
    },
    setDialogGastosCliente(state, dialog) {
      state.dialogGastosCliente = dialog;
    },
    setDialogGastosConsumo(state, dialog) {
      state.dialogGastosConsumo = dialog;
    },
    setTermosPendentes(state, termos) {
      state.termosPendentes = termos;
    },
  },
  actions: {
    async getTermosPendentes(context) {
      context.commit("setTermosPendentes", []);
      try {
        var res = await axios.get(
          "/colaborador/termo-salario-familia-imposto-renda?funcao=TERMOS-APROVAR"
        );
        if (res.data.success) {
          context.commit("setTermosPendentes", res.data.data);
        }
      } catch (error) {
        context.commit("setTermosPendentes", []);
      }
    },
  },
  getters: {},
};

export default homeStore;
